// Central test IDs (kebab-case) — used across the app for the QA agent.
export const HOME = { emergentLink: "home-emergent-link" };

export const LANDING = {
  ctaGetStarted: "landing-cta-get-started",
  ctaSignIn: "landing-cta-sign-in",
  navLogin: "landing-nav-login",
  navRegister: "landing-nav-register",
  moduleTile: (key) => `landing-module-${key}`,
};

export const AUTH = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginError: "login-error",
  regBusiness: "register-business-name",
  regOwner: "register-owner-name",
  regEmail: "register-email",
  regPassword: "register-password",
  regIndustry: "register-industry",
  regSubmit: "register-submit-btn",
  registerError: "register-error",
};

export const SHELL = {
  sidebar: "app-sidebar",
  tenantSwitcher: "app-tenant-switcher",
  themeToggle: "app-theme-toggle",
  logout: "app-logout-btn",
  aiButton: "app-ai-open-btn",
  navLink: (key) => `sidebar-link-${key}`,
  mobileMenuToggle: "app-mobile-menu-toggle",
};

export const DASH = {
  kpiClients: "kpi-clients",
  kpiOrdersToday: "kpi-orders-today",
  kpiRevenue: "kpi-revenue",
  kpiWorkouts: "kpi-workouts",
  chartRevenue: "chart-revenue",
};

export const FIT = {
  newClient: "fitness-new-client-btn",
  clientCard: (id) => `fitness-client-${id}`,
  newWorkout: "fitness-new-workout-btn",
  aiGenerate: "fitness-ai-generate-btn",
  aiGoal: "fitness-ai-goal-input",
  aiDuration: "fitness-ai-duration-input",
};

export const CAFE = {
  menuItem: (id) => `cafe-menu-item-${id}`,
  cartAdd: (id) => `cafe-cart-add-${id}`,
  cartCheckout: "cafe-cart-checkout-btn",
  orderCard: (id) => `cafe-order-${id}`,
  orderAdvance: (id) => `cafe-order-advance-${id}`,
  invNew: "coffee-inv-new-btn",
  invItem: (id) => `coffee-inv-item-${id}`,
  invConsume: (id) => `coffee-inv-consume-${id}`,
  invRestock: (id) => `coffee-inv-restock-${id}`,
  invStatus: (id) => `coffee-inv-status-${id}`,
  invAlertBanner: "coffee-inv-alert-banner",
  invAlertItem: (id) => `coffee-inv-alert-${id}`,
};

export const AI = {
  input: "ai-chat-input",
  send: "ai-chat-send-btn",
  message: (idx) => `ai-chat-message-${idx}`,
};

export const SETTINGS = {
  brandName: "settings-brand-name",
  brandPrimary: "settings-brand-primary",
  brandAccent: "settings-brand-accent",
  brandTagline: "settings-brand-tagline",
  brandSave: "settings-brand-save",
  moduleToggle: (key) => `settings-module-${key}`,
  teamInviteEmail: "settings-team-invite-email",
  teamInviteName: "settings-team-invite-name",
  teamInviteRole: "settings-team-invite-role",
  teamInviteSubmit: "settings-team-invite-submit",
};
